import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hero-museo',
  templateUrl: './hero-museo.component.html',
  styleUrls: ['./hero-museo.component.scss']
})
export class HeroMuseoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
